const Pages = {
  LOGIN: "login",
  NEW_USER: "newUser",
  REGISTRATION: "registration",
  PROFILE: "profile",
  FORGOTTEN_PWD: "forgottenPassword",
  ADMIN: "adminUser",
  EDIT: "editProfile",
  SEARCH: "lawyerSearch",
  NEW_SEARCH: "newSearch",
  TEMPLATE_EDITOR: "templateEditor",
  DOCUMENTS: "documents",
  CALENDAR: "calendar",
  SCORE_CARD: "scoreCard",
  NO_SIDE_MENU: undefined
 };

export default Pages;
